/* eslint-disable import/prefer-default-export */
import { propertyServiceBaseURL } from '../config';
import { BHCustomField } from '../types/bh-custom-field';
import customAxios from '../utilities/axios/customAxios';
import onSuccess from './onSuccess';

export const getCustomFields = (id?: string) => customAxios.get<BHCustomField[]>(`${propertyServiceBaseURL}customfields/externalId/${id}/ownerType/SC_SURVEY`, {
  headers: { surveyId: id },
}).then(onSuccess);
